import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import Header from '../home/components/Header';
import StreamsHero from './components/StreamsHero';
import LiveStreams from './components/LiveStreams';
import ScheduledStreams from './components/ScheduledStreams';
import UploadedVideos from './components/UploadedVideos';
import GoLiveModal from './components/GoLiveModal';
import UploadVideoModal from './components/UploadVideoModal';
import MonetizationModal from './components/MonetizationModal';
import AuthModal from '../../components/feature/AuthModal';

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

export default function Streams() {
  const [showGoLive, setShowGoLive] = useState(false);
  const [showUploadVideo, setShowUploadVideo] = useState(false);
  const [showMonetization, setShowMonetization] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    checkUser();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        setUser(session.user);
      } else if (event === 'SIGNED_OUT') {
        setUser(null);
      }
    });

    // Listen for monetization modal trigger from UserMenu
    const handleOpenMonetization = () => {
      if (user) {
        setShowMonetization(true);
      } else {
        setShowAuthModal(true);
      }
    };

    window.addEventListener('openMonetization', handleOpenMonetization);

    return () => {
      authListener.subscription.unsubscribe();
      window.removeEventListener('openMonetization', handleOpenMonetization);
    };
  }, [user]);

  const checkUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setUser(user);
  };

  const handleGoLiveClick = () => {
    if (user) {
      setShowGoLive(true);
    } else {
      setShowAuthModal(true);
    }
  };

  const handleUploadClick = () => {
    if (user) {
      setShowUploadVideo(true);
    } else {
      setShowAuthModal(true);
    }
  };

  const handleMonetizationClick = () => {
    if (user) {
      setShowMonetization(true);
    } else {
      setShowAuthModal(true);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <div className="pt-16">
        <StreamsHero 
          onGoLiveClick={handleGoLiveClick}
          onUploadClick={handleUploadClick}
          onMonetizationClick={handleMonetizationClick}
        />
        <LiveStreams />
        <ScheduledStreams />
        <UploadedVideos />
      </div>

      {showGoLive && <GoLiveModal onClose={() => setShowGoLive(false)} />}
      {showUploadVideo && <UploadVideoModal onClose={() => setShowUploadVideo(false)} />}
      {showMonetization && <MonetizationModal onClose={() => setShowMonetization(false)} />}
      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} defaultMode="signup" />}
    </div>
  );
}
